"use client";
import { Carousel } from "@material-tailwind/react";
import Image from "next/image";

interface Props {
  items: string[];
  imageClassName?: string;
}
export function HomeCarousel({
  items,
  imageClassName = "w-full h-[225px] md:h-[450px] object-cover transition-all duration-300",
}: Props) {
  return (
    <Carousel
      loop
      autoplay
      transition={{ duration: 2.5 }}
      className="col-span-2"
      prevArrow={({ loop, handlePrev, activeIndex, firstIndex }) => (
        <button
          type="button"
          onClick={handlePrev}
          className="!absolute top-2/4 left-4 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
          aria-label="ก่อนหน้านี้ - ไปยังสไลด์ก่อนหน้า"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="3"
            stroke="currentColor"
            className="h-7 w-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
        </button>
      )}
      nextArrow={({ loop, handleNext, activeIndex, lastIndex }) => (
        <button
          type="button"
          onClick={handleNext}
          className="!absolute top-2/4 right-4 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
          aria-label="ถัดไป - ไปยังสไลด์ถัดไป"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="3"
            stroke="currentColor"
            className="h-7 w-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      )}
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div
          className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2"
          role="tablist"
          aria-label="สไลด์นำทาง"
        >
          {new Array(length).fill("").map((_, i) => (
            <button
              key={i}
              type="button"
              role="tab"
              name={`carousel-slide-${i + 1}`}
              aria-selected={activeIndex === i}
              aria-label={`ไปยังสไลด์ที่ ${i + 1}`}
              className={`block h-1 cursor-pointer rounded-2xl transition-all focus:outline-none focus:ring-2 focus:ring-white/50 ${
                activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
              }`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      )}
    >
      {items.map((image, index) => (
        <div key={`home-carousel-${index}`} className="relative h-full w-full">
          <Image
            src={image}
            alt={`ภาพสไลด์ที่ ${index + 1} - ความสำเร็จของนายหน้าประกันศรีกรุง`}
            fill
            className={imageClassName}
            priority={index < 2}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 60vw"
          />
        </div>
      ))}
    </Carousel>
  );
}
